import { PropsWithChildren, ReactNode } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { IconWrapper } from 'shared/atoms'
import { cn } from 'utils/style'

type FormSectionProps = PropsWithChildren<
	WithClassName<{
		title: string
		description?: string
		icon: ReactNode
		tone?: 'primary' | 'success' | 'warning' | 'danger'
		alignRows?: 'md' | 'lg'
	}>
>

const tones = {
	primary: { bg: 'bg-primary-soft', text: 'text-primary' },
	success: { bg: 'bg-success-soft', text: 'text-success' },
	warning: { bg: 'bg-warning-soft', text: 'text-warning' },
	danger: { bg: 'bg-danger-soft', text: 'text-danger' }
}

const alignRowsClassNames = {
	md: { section: 'md:row-span-2 md:grid md:grid-rows-[subgrid]', header: 'md:mb-0' },
	lg: { section: 'lg:row-span-2 lg:grid lg:grid-rows-[subgrid]', header: 'lg:mb-0' }
}

export const FormSection = ({
	title,
	description,
	icon,
	tone = 'primary',
	alignRows,
	className,
	children
}: FormSectionProps) => (
	<section
		className={cn(
			'rounded-lg border border-border bg-card p-5 shadow-panel sm:p-6',
			alignRows && alignRowsClassNames[alignRows].section
		)}>
		<div
			className={cn(
				'mb-5 flex items-start gap-3',
				alignRows && alignRowsClassNames[alignRows].header
			)}>
			<IconWrapper iconBgColor={tones[tone].bg} iconColor={tones[tone].text}>
				{icon}
			</IconWrapper>
			<div className="min-w-0">
				<h2 className="font-display text-base font-semibold text-foreground">{title}</h2>
				{description && <p className="text-xs text-muted-foreground">{description}</p>}
			</div>
		</div>
		<div className={cn('grid content-start gap-4 sm:grid-cols-2', className)}>{children}</div>
	</section>
)
